module.exports = __webpack_public_path__ + "assets/f1a5fd8e76fb7dcb30a3910207f19943.mp3";